import messageActions   from './messages/actions';
import messageGetters   from './messages/getters';
import messageMutations from './messages/mutations';
import messageState     from './messages/state';

import notificationActions   from './notifications/actions';
import notificationGetters   from './notifications/getters';
import notificationMutations from './notifications/mutations';
import notificationState     from './notifications/state';

import toastActions   from './toasts/actions';
import toastMutations from './toasts/mutations';
import toastState     from './toasts/state';

import mutations   from './mutations';
import eventHandlers   from './eventHandlers';

export default {
    namespaced: true,
    actions: {
        ...messageActions,
        ...notificationActions,
        ...eventHandlers,
        ...toastActions,
    },
    getters: {
        ...messageGetters,
        ...notificationGetters,
    },
    mutations: {
        ...messageMutations,
        ...notificationMutations,
        ...toastMutations,
        ...mutations,
    },
    state: {
        ...messageState,
        ...notificationState,
        ...toastState,
        activeTab: 'messages',
    },
};
